'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderTypes = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _immutable = require('immutable');

var _editors = require('./editors');

var _editors2 = _interopRequireDefault(_editors);

var _ObjectEditor = require('./ObjectEditor');

var _ObjectEditor2 = _interopRequireDefault(_ObjectEditor);

var _PublishActions = require('../components/PublishActions');

var _PublishActions2 = _interopRequireDefault(_PublishActions);

var _TypeContext = require('./TypeContext');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var reservedProperties = ["type", "label", "description", "order", "publishable", "deletable", "defaultValue", "values", "of", "editor"];

var orderTypes = exports.orderTypes = function orderTypes(type, order) {
  if ((typeof order === 'undefined' ? 'undefined' : (0, _typeof3.default)(order)) === 'object' && !Array.isArray(order)) {
    order = (0, _lodash.values)(order);
  }

  var comparator = order ? function (a, b) {
    a = order.indexOf(a);
    b = order.indexOf(b);
    a = a < 0 ? 1000 : a;
    b = b < 0 ? 1000 : b;
    return a > b ? 1 : b > a ? -1 : 0;
  } : undefined;
  return (0, _immutable.OrderedMap)(type) // .filterNot((v, k) => reservedProperties.indexOf(k) >= 0)
  .sortBy(function (v, k) {
    return k;
  }, comparator);
};

var editor = function editor(name, type, context) {
  var editor = type.editor;
  var Editor = _editors2.default[editor];

  if (!Editor) {
    console.log("No editor defined for type '%s' @ %s - make sure an Editor is defined in the hierarchy", name, type);
    return _react2.default.createElement('div', null, 'No editor defined for type ', name);
  }

  return _react2.default.createElement(_PublishActions2.default, {
    type: type,
    context: context
  }, _react2.default.createElement(Editor, {
    name: name,
    type: type,
    context: context
  }));
};

var nestedType = function nestedType(name, type, context, resolveType) {
  if ((typeof type === 'undefined' ? 'undefined' : (0, _typeof3.default)(type)) === 'object') {
    var typeName = typeof type === "string" ? type : type.type;
    var merged = (0, _extends3.default)({}, resolveType(typeName), (0, _lodash.omit)(type, 'type'));
    return _react2.default.createElement(TypeEditor, {
      name: name,
      type: merged,
      context: context
    });
  }
};

var implicitType = function implicitType(name, type, context) {
  return _react2.default.createElement(_PublishActions2.default, {
    type: objectType,
    context: context
  }, _react2.default.createElement(_ObjectEditor2.default, {
    name: name,
    type: objectType,
    context: context
  }));
};

var guard = function guard(field, name, path) {
  console.error("No %s supplied for %s @ %s", field, name);
  return _react2.default.createElement('div', null, 'No ', field, ' supplied for ', name, ' @ ', path);
};

var TypeEditor = (0, _TypeContext.withTypes)(function (_ref) {
  var name = _ref.name,
      type = _ref.type,
      context = _ref.context,
      resolveType = _ref.resolveType;
  type = type || resolveType(name);
  var path = context.path;

  if (context === undefined) {
    return guard("context", name, path);
  }

  if (path === undefined) {
    return guard("path", name, path);
  }

  if (!Array.isArray(path)) {
    return guard("path as array", name, path);
  }

  if (name === undefined) {
    return guard("name", name, path);
  }

  if (!type) {
    console.error('No type defined for ' + name);
    return _react2.default.createElement('div', null, 'No type defined for ', name);
  }

  var result = undefined;

  if (type.editor) {
    result = editor(name, type, context);
  } else if (typeof type === "string") {
    // A simple type is one where the key just maps to a string defining the type
    result = nestedType(name, resolveType(type), context, resolveType);
  } else if (type.type) {
    // A nested type is defined where the type object contains a type
    result = nestedType(name, type, context, resolveType); // } else {
    //     result = implicitType(name, type, context)
  }

  if (result) {
    return result;
  } else {
    console.error('No result type editor created for ' + name, path, name, type);
    return _react2.default.createElement('div', null, 'No type defined for ', name);
  }
});
exports.default = TypeEditor;